module.exports = __webpack_public_path__ + "d94e20c1/img/ion_calendar-number.3ac5bd07.svg";